import styled from 'styled-components';

export const Title = styled.div`
  font-weight: 400;
  font-size: 12.5px;
  line-height: 2.08;
  user-select: none;
  text-transform: capitalize;
  color: #AFB1BC;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const OptionsCount = styled.div`
  background-color: #edf2f7;
  border-radius: 2em;
  color: #122d46;
  font-size: 9.5px;
  font-weight: 900;
  display: inline-block;
  line-height: 1;
  min-width: 1;
  padding: 3px 8px;
  text-align: center;
  box-shadow: inset 0 0 12px 0 rgba(0, 0, 0, 0.13);
`;

export const Label = styled.div`
`;

const backgroundColorFunc = (isFocused, required) => {
  if (isFocused) return '#edf2f7';
  else if (required) return 'rgba(255,86,48,0.1)';
  else return 'white';
};

const borderStyle = (isDisabled, isFocused) => {
  if (isFocused) return 'solid 2px #006fc9;';
  else if (isDisabled) return 'none';
  else return 'solid 1px #122d46;';
};
export const dropdownStyle = {
  container: (provided, props) => ({
    ...provided,
    width: '100%'
  }),
  control: (provided, { isDisabled, isFocused }) => ({
    'display': 'flex',
    'height': '38px',
    'minWidth': '180px',
    'borderRadius': '3px',
    'backgroundColor': isDisabled ? '#d9e3e9' : '#ffffff',
    'border': borderStyle(isDisabled, isFocused),
    'color': isDisabled ? '#abc1cd' : '#122d46',
    'paddingLeft': '10px',
    'fontWeight': '700',
    'textOverflow': 'ellipsis',
    'overflow': 'hidden',
    '&:hover': {
      borderColor: '#31556d',
      color: '#31556d'
    },
    '&:active': {
      borderColor: '#4f7d94',
      color: '#4f7d94'
    }
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  placeholder: (provided, { isDisabled }) => ({
    ...provided,
    fontFamily: 'CentraNo2',
    fontSize: '14px',
    color: 'inherit',
    opacity: isDisabled ? 0.5 : 0.7,
    fontWeight: 300
  }),
  input: (provided) => ({
    ...provided,
    fontFamily: 'CentraNo2',
    fontSize: '14px',
    color: '#122d46',
    fontWeight: 300,
    margin: 'auto'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: 'inherit',
    width: '30px'
  }),
  option: (provided, { isFocused, data }) => ({
    ...provided,
    fontFamily: 'CentraNo2',
    backgroundColor: backgroundColorFunc(isFocused, data.required),
    fontSize: '14px',
    textAlign: 'left',
    color: '#122d46',
    cursor: isFocused ? 'pointer' : 'default',
    paddingLeft: '22px',
    paddingRight: '22px',
    height: '36px',
    textTransform: 'none',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }),
  valueContainer: (provided) => ({
    ...provided,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginRight: 'auto'
  }),
  menu: () => ({
    position: 'absolute',
    marginTop: '6px',
    zIndex: 5000,
    width: '100%',
    border: 'none',
    borderRadius: '3px',
    backgroundColor: '#fff',
    boxShadow: '2px 2px 30px 0 #d5dee6',
    minWidth: '190px'
  }),
  menuList: () => ({
    maxHeight: '250px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: '#122d46', width: 'fit-content', height: '19px', fontSize: '14px', fontWeight: 400, top: '8px', position: 'relative'
    };
  },
  multiValue: (provided, state) => ({
    ...provided,
    backgroundColor: state?.data?.required ? '#bec8d2' : '#edf2f7',
    color: '#63758d',
    fontSize: '11.5px',
    fontWeight: 500

  }),
  multiValueLabel: (provided, state) => (state.data.required
    ? {
        ...provided, fontWeight: 'bold', color: 'white', paddingRight: 6
      }
    : provided),
  multiValueRemove: (provided, state) => (state.data.required ? { ...provided, display: 'none' } : provided)
};

export const inputDropdownStyle = (theme) => ({
  control: (provided, { isDisabled }) => ({
    display: 'flex',
    minHeight: '35px',
    backgroundColor: isDisabled ? '#edf2f7' : `${theme.backgrounds.actionDropDown} !important`,
    border: 'solid 1px #fafbfc',
    borderBottomWidth: '0px',
    color: 'white',
    paddingLeft: '10px',
    fontWeight: '700',
    textOverflow: 'ellipsis',
    borderLeft: '12px solid #53a9ff'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  placeholder: (provided, { isDisabled }) => ({
    ...provided,
    fontSize: '13px',
    color: theme.selector.text,
    opacity: isDisabled ? 0.5 : 0.7,
    fontWeight: 300
  }),
  input: (provided) => ({
    ...provided,
    fontSize: '13px',
    color: '#1c2243',
    fontWeight: 300
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#505965',
    width: '30px'
  }),
  option: (provided, { isFocused, data }) => ({
    ...provided,
    backgroundColor: theme.backgrounds.actionDropDown,
    fontSize: '14px',
    textAlign: 'left',
    color: theme.text.actionDropDownItem,
    cursor: isFocused ? 'pointer' : 'default',
    paddingLeft: '22px',
    paddingRight: '22px',
    height: '36px',
    textTransform: 'none',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }),
  valueContainer: () => ({
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    marginRight: 'auto'
  }),
  menu: () => ({
    position: 'absolute',
    marginTop: '6px',
    zIndex: 5000,
    width: '100%',
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.actionDropDown,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    minWidth: '190px'
  }),
  menuList: () => ({
    maxHeight: '250px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.text.actionDropDownTitle, width: 'fit-content', height: '19px', fontSize: '14px', fontWeight: 400, top: '8px', position: 'relative'
    };
  },
  multiValue: (provided, state) => ({
    ...provided,
    backgroundColor: state?.data?.required ? '#bec8d2' : '#edf2f7',
    color: '#63758d',
    fontSize: '11.5px',
    fontWeight: 500

  }),
  multiValueLabel: (provided, state) => (state.data.required
    ? {
        ...provided, fontWeight: 'bold', color: 'white', paddingRight: 6
      }
    : provided),
  multiValueRemove: (provided, state) => (state.data.required ? { ...provided, display: 'none' } : provided)
});

export const Input = styled.input`
height: 35px;
border-radius: 1px;
background-color: #ffffff;
border: solid 1px #fafbfc;
padding-left: 10px;
font-weight: 300;
font-size: 14px;
`;
